import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css'
import './index.css'

// Import store and contexts
import { store } from './store'
import { ThemeProvider } from './contexts/ThemeContext'
import ToastContainerThemed from './components/ToastContainerThemed'

// Import router
import { router } from './routes/routes'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <RouterProvider router={router} />
        <ToastContainerThemed />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
)
